import { render, staticRenderFns } from "./TokenRoyaltyFields.vue?vue&type=template&id=2c958b3a"
import script from "./TokenRoyaltyFields.vue?vue&type=script&lang=js"
export * from "./TokenRoyaltyFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports